import reducer from './reducer';
export * from './actions';
export * from './selectors';

export default { reducer };
